import styled from '@emotion/styled';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import React from 'react';
import { injectIntl } from 'react-intl';
import { messages } from '../../messages';
import { N800, N20, N0, B400, B200 } from '@atlaskit/theme/colors';
import { AtlassianLogo } from '@atlaskit/logo';
import Button from '@atlaskit/button';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export type ErrorLocaleProps = {
  readonly locale?: string;
};

function ErrorLocale({ locale }: ErrorLocaleProps) {
  const { createAnalyticsEvent } = useAnalyticsEvents();

  React.useEffect(() => {
    createAnalyticsEvent({
      event: 'blocked',
      action: 'blocked',
      actionSubject: 'signUp',
      actionSubjectId: 'signUpForm',
      product: 'marketing',
      blockType: 'geoIP',
      blockValue: locale
    }).fire();
  }, []);

  return (
    <Root>
      <LogoContainer>
        <AtlassianLogo
          textColor={B400}
          iconColor={B200}
          iconGradientStart={B400}
          iconGradientStop={B200}
        />
      </LogoContainer>
      <h2>
        <SanitizedFormattedHtmlMessage {...messages.localeError} />
      </h2>
      <p>
        <SanitizedFormattedHtmlMessage {...messages.localeErrorMessage} />
      </p>

      <Button
        appearance="link"
        href={
          'https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine'
        }
      >
        <SanitizedFormattedHtmlMessage {...messages.localeErrorButton} />
      </Button>
    </Root>
  );
}

ErrorLocale.messages = messages;
export default injectIntl(ErrorLocale);

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: ${N0} !important;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  color: ${N800};

  h2 {
    padding-top: 22px !important;
  }

  p {
    width: 370px;
  }

  button {
    padding-top: 10px;
  }
`;
const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 300px;
  background-color: ${N20};
`;
